<template>
  <v-app>
    <v-app-bar
      app
      :color="colores.azul_claro"
      :height="altura"
      elevation="0"
      dark
      class="d-none d-md-block"
    >
      <!-- Contenido Header en Desktop -->
      <router-link to="/">
        <div
          class="d-none d-md-flex align-center"
          style="width: 300px; background-color: white; height: 70px"
        >
          <img
            alt="Visión Laser San Luis Logo"
            class="mx-auto"
            contain
            src="@/assets/img/logo/logo.png"
            width="80"
          />
        </div>
      </router-link>

      <div class="d-none d-md-flex align-center ml-5">
        <router-link to="/" class="d-inline-block mr-5">Inicio</router-link>
        <router-link to="/nosotros" class="d-inline-block mr-5">Nosotros</router-link>
        <router-link to="/servicios" class="d-inline-block mr-5">Servicios</router-link>
        <router-link to="/nuestros-especialistas" class="d-inline-block mr-5">Nuestros Especialistas</router-link>
        <router-link to="/contacto" class="d-inline-block mr-5">Contacto</router-link>
        <router-link to="/pago-en-linea" class="d-inline-block mr-5">Agenda tu consulta</router-link>
      </div>

      <v-spacer class="d-none d-md-block"></v-spacer>

      <!-- <div class="d-none d-md-flex align-center pr-12">
        <router-link to="/Tienda" class="gotham bold d-inline-block mr-5">Tienda en Línea</router-link>
        <router-link to="blog" class="gotham bold d-inline-block">Blog</router-link>
      </div>-->
      <!-- Termina contenido Header en Desktop -->

      <!-- Contenido Header en Móvil -->
      <div class="d-flex d-md-none">
        <v-btn text :ripple="false" @click="toggle_menu()">
          <v-icon size="32" color="white">mdi-menu</v-icon>
        </v-btn>
      </div>

      <v-spacer class="d-block d-md-none"></v-spacer>

      <!-- <div class="d-flex d-md-none menu_responsive" v-bind:class="{'menu-abierto' : menu_abierto}">
        <v-row>
          <v-col cols="12">
            <router-link to="/">
              <v-img
                src="@/assets/img/logo/logo-blanco.png"
                class="d-block mx-auto mt-12"
                width="80px"
              ></v-img>
            </router-link>


            <div class="text-center mt-12" id="responsive-items">
              <router-link to="/nosotros" class="d-block mx-auto font-size-20">Nosotros</router-link>
              <router-link to="/servicios" class="d-block mx-auto font-size-20">Servicios</router-link>
              <router-link
                to="/nuestros-especialistas"
                class="d-block mr-5 mx-auto font-size-20"
              >Nuestros Especialistas</router-link>
              <router-link to="/contacto" class="d-block mx-auto font-size-20">Contacto</router-link>
            </div>

            <div class="mt-12 tienda-blog-btns">
              <ul class="px-0">
                <li>
                  <router-link
                    to="/Tienda"
                    class="exo bold btn-responsive-menu btn-azul-fuerte"
                  >TIENDA</router-link>
                </li>
                <li>
                  <router-link to="blog" class="exo bold btn-responsive-menu btn-azul-celeste">BLOG</router-link>
                </li>
              </ul>
              <v-btn
                color="#2D4A7B"
                block
                class="blanco"
                :ripple="false"
                height="70px"
                tile
                style="text-transform: initial;"
                elevation="0"
              >
                <span class="gotham" style="font-size: 16px; letter-spacing: 0; padding-right: 52px;">Programa una cita</span>
                
                <v-icon color="#ffffff80">mdi-chevron-right</v-icon>
                <v-icon color="#ffffffb3">mdi-chevron-right</v-icon>
                <v-icon color="#ffffff">mdi-chevron-right</v-icon>
              </v-btn>
            </div>
            
            <div style="background:#C0C0C0;" class="redes-sociales">
              <v-row align="center">
                <v-col cols="5" offset="1" class="text-right" style="position:relative">
                  <div class="button-rounded">
                    <a href="#" class="facebook-btn">
                      <v-icon color="#C0C0C0">mdi-facebook</v-icon>
                    </a>
                  </div>
                </v-col>
                <v-col cols="1">|</v-col>
                <v-col cols="5" class="text-left instagram-social" style="position:relative;">
                  <div class="button-normal">
                    <a href="#" class="instagram-btn">
                      <v-icon color="#898989">mdi-instagram</v-icon>
                    </a>
                  </div>
                </v-col>
              </v-row>
              <div class="list-redes-sociales">
                <ul>
                  <li>
                    <a href="#" class="facebook-btn"><v-icon color="red">mdi-facebook</v-icon></a>
                  </li>
                  <li>
                   
                  </li>
                </ul>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>-->

      <v-spacer class="d-block d-md-none"></v-spacer>
      <v-spacer class="d-block d-md-none"></v-spacer>

      <!-- Termina contenido Header en Móvil -->
    </v-app-bar>
    <!-- pendiente -->
    <section style="z-index: 65;" id="menu-responsive-style">
      <div class="d-flex d-md-none">
        <v-btn
          color="#2D4A7B"
          elevation="0"
          tile
          :ripple="false"
          @click="toggle_menu()"
          fixed
          style="z-index: 25;"
        >
          <v-icon size="32" color="white">mdi-menu</v-icon>
        </v-btn>
      </div>
      <div class="d-flex d-md-none menu_responsive" v-bind:class="{'menu-abierto' : menu_abierto}">
        <v-row>
          <v-col cols="12">
            <router-link to="/">
              <v-img
                src="@/assets/img/logo/logo-blanco.png"
                class="d-block mx-auto mt-12"
                width="80px"
              ></v-img>
            </router-link>

            <div class="text-center mt-12" id="responsive-items">
              <router-link to="/nosotros" class="d-block mx-auto font-size-20 exo">Nosotros</router-link>
              <router-link to="/servicios" class="d-block mx-auto font-size-20 exo">Servicios</router-link>
              <router-link
                to="/nuestros-especialistas"
                class="d-block mr-5 mx-auto font-size-20 exo"
              >Nuestros Especialistas</router-link>
              <router-link to="/contacto" class="d-block mx-auto font-size-20 exo">Contacto</router-link>
              <router-link
                to="/pago-en-linea"
                class="d-block mx-auto font-size-20 exo"
              >Agenda tu consulta</router-link>
            </div>

            <div class="mt-12 tienda-blog-btns d-none">
              <ul class="px-0">
                <li>
                  <router-link
                    to="/Tienda"
                    class="exo bold btn-responsive-menu btn-azul-fuerte"
                  >TIENDA</router-link>
                </li>
                <li>
                  <router-link to="blog" class="exo bold btn-responsive-menu btn-azul-celeste">BLOG</router-link>
                </li>
              </ul>
              <router-link to="/contacto">
                <v-btn
                  color="#2D4A7B"
                  block
                  class="blanco"
                  :ripple="false"
                  height="70px"
                  tile
                  style="text-transform: initial;"
                  elevation="0"
                >
                  <span
                    class="gotham"
                    style="font-size: 16px; letter-spacing: 0; padding-right: 52px;"
                  >Programa una cita</span>

                  <v-icon color="#ffffff80">mdi-chevron-right</v-icon>
                  <v-icon color="#ffffffb3">mdi-chevron-right</v-icon>
                  <v-icon color="#ffffff">mdi-chevron-right</v-icon>
                </v-btn>
              </router-link>
            </div>

            <div style="background:#C0C0C0;" class="redes-sociales">
              <v-row align="center">
                <v-col cols="5" offset="1" class="text-right" style="position:relative">
                  <div class="button-rounded">
                    <a
                      href="https://www.facebook.com/VisionLaserSL/"
                      target="_blank"
                      class="facebook-btn"
                    >
                      <v-icon color="#C0C0C0">mdi-facebook</v-icon>
                    </a>
                  </div>
                </v-col>
                <v-col cols="1">|</v-col>
                <v-col cols="5" class="text-left instagram-social" style="position:relative;">
                  <div class="button-normal">
                    <a
                      href="https://www.instagram.com/visionlasersl/"
                      target="_blank"
                      class="instagram-btn"
                    >
                      <v-icon color="#898989">mdi-instagram</v-icon>
                    </a>
                  </div>
                </v-col>
              </v-row>
              <!-- <div class="list-redes-sociales">
                  <ul>
                    <li>
                      <a href="#" class="facebook-btn"><v-icon color="red">mdi-facebook</v-icon></a>
                    </li>
                    <li>
                     
                    </li>
                  </ul>
              </div>-->
            </div>
          </v-col>
        </v-row>
      </div>
    </section>

    <!-- pendiente -->

    <v-content>
      <router-view />
    </v-content>

    <v-footer :color="colores.azul_oscuro" padless height="365">
      <!-- Contenido Footer en Móvil -->
      <v-container class="d-md-none py-0">
        <v-row>
          <v-col class="px-0 py-0">
            <v-btn
              color="#373737"
              block
              class="blanco"
              :ripple="false"
              height="40px"
              tile
              style="text-transform: initial;"
              @click="$vuetify.goTo(number)"
            >
              <v-icon>mdi-chevron-up</v-icon>
              <v-spacer></v-spacer>
              <span class="gotham" style="font-size: 13px;">Volver arriba</span>
              <v-spacer></v-spacer>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="px-0 py-0">
            <router-link to="/contacto" style="text-decoration:none;">
              <v-btn
                color="#11274C"
                block
                class="blanco"
                :ripple="false"
                height="40px"
                tile
                style="text-transform: initial;"
              >
                <span class="gotham" style="font-size: 14px;">Programa una cita</span>
                <v-spacer></v-spacer>
                <v-icon color="#ffffff80">mdi-chevron-right</v-icon>
                <v-icon color="#ffffffb3">mdi-chevron-right</v-icon>
                <v-icon color="#ffffff">mdi-chevron-right</v-icon>
              </v-btn>
            </router-link>
          </v-col>
        </v-row>

        <v-row class="blanco" style="height: 225px; background-color: #2D4A7B;" align="center">
          <v-col class="text-center pt-10">
            <v-img src="@/assets/img/logo/logo-blanco.png" width="94px" class="mx-auto"></v-img>

            <span
              class="d-block mx-auto mt-12 exo bold"
              style="font-size: 12px;"
            >Visión Láser San Luis</span>
            <span class="blanco d-block exo bold cursor-pointer" style="font-size: 12px;" @click="avisoPrivacidadModal = true">
              Aviso de privacidad
            </span>
            <span
              class="d-block mx-auto gotham"
              style="font-size: 12px;"
            >Todos los Derechos Reservados</span>
          </v-col>
        </v-row>
      </v-container>
      <!-- Termina contenido Footer en Móvil -->

      <!-- Contenido Footer en Desktop -->
      <v-container class="d-none d-md-block">
        <v-row align="center">
          <v-col>
            <router-link
              to="/nosotros"
              class="d-block blanco not-underlined mb-4"
              style="font-size: 16px;"
            >Nosotros</router-link>
            <router-link
              to="/nuestros-especialistas"
              class="d-block blanco not-underlined mb-4"
              style="font-size: 16px;"
            >Nuestros Especialistas</router-link>
            <router-link
              to="/servicios"
              class="d-block blanco not-underlined mb-4"
              style="font-size: 16px;"
            >Servicios</router-link>
            <router-link
              to="/tienda"
              class="exo bold blanco not-underlined mb-4"
              style="font-size: 16px;"
            >
              Tienda en
              Línea
            </router-link>
          </v-col>
          <v-col class="text-center">
            <v-img src="@/assets/img/logo/logo-blanco.png" width="156px" class="mx-auto"></v-img>

            <span
              class="blanco gotham d-block mx-auto my-12"
              style="max-width: 408px; font-size: 16px;"
            >
              Somos el centro
              de más alta especialidad en oftalmología para el cuidado de tus ojos.
            </span>

            <span class="blanco">
              Visión Láser San Luis
              <span class="d-inline-block mx-2">|</span> San Luis Potosí, SLP
            </span>

            <span class="blanco d-block mt-3 cursor-pointer" @click="avisoPrivacidadModal = true">
              Aviso de privacidad
            </span>
          </v-col>
          <v-col class="text-right">
            <a
              href="https://www.facebook.com/VisionLaserSL/"
              target="_blank"
              class="d-block blanco not-underlined mb-5"
            >Facebook</a>
            <a
              href="https://www.instagram.com/visionlasersl/"
              target="_blank"
              class="d-block blanco not-underlined mb-5"
            >Instagram</a>
            <a
              href="https://www.youtube.com/visionlaserslp"
              target="_blank"
              class="d-block blanco not-underlined mb-5"
            >YouTube</a>
          </v-col>
        </v-row>
      </v-container>
      <!-- Termina contenido Footer en Desktop -->
    </v-footer>

    <!-- inicia aviso de privacida -->
    <AvisoPrivacidad :visible="avisoPrivacidadModal" @close="avisoPrivacidadModal = false" />
    <!-- termina aviso de privacida -->


  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld";
import * as easings from "vuetify/es5/services/goto/easing-patterns";
import AvisoPrivacidad from './components/AvisoPrivacidad';

export default {
  name: "App",

  components: {
    HelloWorld,
    AvisoPrivacidad
  },

  data: () => ({
    number: -9999,
    colores: {
      azul_claro: "#2D4A7B",
      azul_oscuro: "#11274C"
    },
    menu_abierto: false,
    altura: 70,
    avisoPrivacidadModal: false
  }),

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    toggle_menu: function() {
      this.menu_abierto = !this.menu_abierto;
    },
    onResize() {
      if (window.innerWidth < 961) {
        this.altura = 50;
      } else {
        this.altura = 70;
      }
    }
  },
  watch: {
    $route(to, from) {
      this.menu_abierto = false;
    }
  }
};
</script>